


























import EntryListing from '/components/globals/listings/entry-listing'

export default

	props: block: Object

	components: {
		EntryListing
	}

	methods:
		button: (category) ->
			label: 'View More'
			to: "/learn/category/#{category.slug}"

